export default "__VITE_ASSET__DTtOXnL$__"